// Helpers to tie the open problems of a vehicle (problemkendaraan) to the rows of a checklist card.
// problem.pengecekan_mobil_detil_id points to an old detil row, so a problem is matched to the current
// row by keterangan + label_grup.

// status of a problem: 1 baru, 2 schedule, 3 solved, 4 ignore (see features/problem/utils/problemConstants.js)
export const isSolvedProblem = (problem) =>
  problem.status === 3 || !!problem.tanggal_selesai;

export const isIgnoredProblem = (problem) => problem.status === 4;

// A problem younger than this many days is a new problem, an older one is an old problem.
const NEW_PROBLEM_MAX_DAYS = 7;

// splits the problems into the new ones (younger than 7 days) and the old ones
export const splitProblemsByAge = (listProblemData) => {
  const newProblems = [];
  const oldProblems = [];
  (listProblemData || []).forEach((problem) => {
    const days = (new Date() - new Date(problem.tanggal)) / (1000 * 60 * 60 * 24);
    (days < NEW_PROBLEM_MAX_DAYS ? newProblems : oldProblems).push(problem);
  });
  return { newProblems, oldProblems };
};

// two gambar urls are the same file (the ?serial= only busts the browser cache)
export const isSameGambar = (a, b) => {
  if (!a || !b) return false;
  return a.split("?serial=")[0] === b.split("?serial=")[0];
};

// the open problem of a checklist row (detil), undefined when it has none
export const findProblem = (listProblemData, detil) => {
  if (!listProblemData || !detil) return undefined;
  return listProblemData.find(
    (problem) =>
      !isSolvedProblem(problem) &&
      problem.keterangan === detil.keterangan &&
      problem.label_grup === detil.label_grup
  );
};

// the berangkat row of a kembali row (berangkatDetils: the berangkat rows, only given on kembali)
const findBerangkatDetil = (berangkatDetils, detil) =>
  berangkatDetils
    ? berangkatDetils.find(
        (el) =>
          el.keterangan === detil.keterangan && el.label_grup === detil.label_grup
      )
    : undefined;

// The page copies the berangkat note into a kembali row that has no note. A kembali note identical to the berangkat
// note is that copy: it is not something written on kembali (berangkatDetils: the berangkat rows, only given on kembali).
export const isCopiedFromBerangkat = ({ detil, berangkatDetils }) => {
  const berangkat = findBerangkatDetil(berangkatDetils, detil);
  return (
    !!berangkat &&
    !!berangkat.note &&
    !!detil.note &&
    berangkat.note.trim() === detil.note.trim()
  );
};

// An UNCHECKED row is a new problem when it has no open problem yet, or (kembali) when it was checked on berangkat:
// it was fine when the vehicle left, so what is wrong now happened during the trip.
// A row that is unchecked on berangkat too only continues a known problem.
export const isNewProblem = ({ detil, listProblemData, berangkatDetils }) => {
  if (!findProblem(listProblemData, detil)) return true;
  const berangkat = findBerangkatDetil(berangkatDetils, detil);
  return !!berangkat && berangkat.cek === 1;
};

// a row whose option needs a photo (required_gambar)
export const isRequiredGambar = (detil) =>
  !!detil && [1, "1", true].includes(detil.required_gambar);

// ... and has none yet
export const isMissingRequiredGambar = (detil) =>
  isRequiredGambar(detil) && !detil.gambar;

// the unchecked rows that are a new problem and still miss a note or a gambar
// listProblemData undefined: the card has no problem data, nothing is checked
// On kembali the note copied from berangkat does not count as a note.
export const findMissingNewProblems = ({
  detils,
  listProblemData,
  berangkatDetils,
}) => {
  if (!listProblemData) return [];
  return detils.filter((detil) => {
    if (detil.cek === 1) return false;
    if (!isNewProblem({ detil, listProblemData, berangkatDetils })) return false;

    return (
      !detil.note ||
      isCopiedFromBerangkat({ detil, berangkatDetils }) ||
      !detil.gambar
    );
  });
};
